import { Map } from 'immutable';

export default new Map();
